export const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingTop: '32px'
	},
	button_group: {
		display: 'flex'
	},
	buttons: {
		marginRight: '8px'
	},
	title: {
		flexGrow: 1,
		fontWeight: 600
	}
};
